import React from 'react';
import {LoadingSpinner} from '@albert-io/atomic';
import PracticeView from 'components/PracticeView/PracticeView.react';
import TitleBar from 'components/PracticeView/TitleBar/TitleBar.react';

import './loading-view.scss';

const LoadingView = () => {
  return (
    <PracticeView
      titleBar={<TitleBar className='u-bgc_blue-500' />}
      stageComponent={
        <div className='practice-view-spinner-wrapper'>
          <LoadingSpinner size={2} />
        </div>
      }
    />
  );
};

export default LoadingView;
